// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7a2cb9d2","703":"ef00b947","787":"1afddbf2"}[chunkId] + ".chunk.js";
};